import React from "react";
import { rollbarInstance } from "../../utils/rollbar";

/**
 * Fallback UI shown when a descendant component throws during render.
 *
 * @param {{ error: Error }} props
 * @returns {JSX.Element}
 */
function Fallback({ error }) {
  return (
    <div className="container">
      <h1 className="text-center">Something went wrong </h1>
      <code className="text-center">
        Message - {JSON.stringify(error?.message, null, 5)}
      </code>
      <br />
      <br />
      <br />
      <code className="text-center">
        Stack - {JSON.stringify(error?.stack, null, 5)}
      </code>
    </div>
  );
}

/**
 * Catches render-time errors in the React tree and reports them to Rollbar
 * when a configured instance is available (rollbarInstance is null in local
 * dev when REACT_APP_ROLLBAR_ACCESS_TOKEN is unset).
 */
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    rollbarInstance?.error(error, info);
  }

  render() {
    if (this.state.error) {
      return <Fallback error={this.state.error} />;
    }
    return this.props.children;
  }
}
